import { asyncTimeout } from '@utils/common';
import { userIdentityStore } from './user-identity.state.js';

async function resolveUser() {
  while (true) {
    const state = userIdentityStore.getState();
    if (state.user !== void 0) {
      return state.user;
    }
    await asyncTimeout(100);
  }
}

export { resolveUser };
//# sourceMappingURL=promise.has-resolved-user.js.map
